import { apiGet } from '@jumbo/utils/ApiHelper';
import config from 'config';
const apiUrl = config.apiUrl;

export function getStatisticsApi(data) {
  return apiGet(apiUrl, 'admin/api/dashboard', data);
}

export function getUserStatsApi(data) {
  return apiGet(apiUrl, 'admin/api/dashboard/users/stats', data);
}

export function getUserLocationsApi(data) {
  return apiGet(apiGet, 'admin/api/stats/locations', data);
}
